import React from 'react';
import PropTypes from 'prop-types';

function CustomizedAxisTick({ x, y, payload, rotate }) {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={16}
                textAnchor="end"
                fill="#666"
                transform={rotate}
            >
                {payload.value}
            </text>
        </g>
    );
}

CustomizedAxisTick.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    payload: PropTypes.object,
    rotate: PropTypes.string,
};

CustomizedAxisTick.defaultProps = {
    x: 0,
    y: 0,
    payload: {},
    rotate: 'rotate(-35)',
};

export default CustomizedAxisTick;
